import BookingPage from "./BookingPage";
export default function AcademyBooking() { return <BookingPage type="academy" />; }
